import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Benedict Kpaduwa </span>
            from <span className="purple"> Lagos, Nigeria.</span>
            <br />I'm a creative full stack and mobile applications developer with experience 
            in a variety of exciting projects. A level head and rational approach to problem solving 
            combined with a passion for innovative and fresh ideas has led to a portfolio of impressive 
            website solutions. Technically competent and industry aware means that each project is undertaken
             with the most up-to-date and relevant programming foundations available. A strong communicator with 
             the ability to convey ideas clearly with an emphasis on client satisfaction.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Call of Duty Mobile
            </li>
            <li className="about-activity">
              <ImPointRight /> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!!"{" "}
          </p>
          <footer className="blockquote-footer">Benedict</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
